import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function UpcomingEventsBanner({ topSlot = false }) {
  return (
    <section
      aria-labelledby="upcoming-events-banner-title"
      data-testid="upcoming-events-banner"
      className={`relative overflow-hidden border-y border-gold/30 bg-ink ${topSlot ? "pt-24 md:pt-28" : ""}`}
    >
      <Link
        to="/calendar"
        data-testid="upcoming-events-banner-link"
        aria-label="See all upcoming events at Beth El Center for Jewish Life"
        className="relative block max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 cursor-pointer group"
      >
        <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase text-gold mb-3">Beth El Center for Jewish Life</p>
        <h2 id="upcoming-events-banner-title" className="font-syne font-extrabold uppercase tracking-tighter leading-[0.95] text-[2rem] md:text-[3.4rem]">
          Upcoming <span className="text-gold">Events</span>
        </h2>
        <p className="mt-4 font-cormorant italic text-xl md:text-2xl text-foreground/85">
          Services, classes, and celebrations — there's always something happening at Beth El.
        </p>
        <span
          data-testid="upcoming-events-banner-cta"
          className="mt-8 inline-flex items-center gap-3 px-8 py-4 bg-gold text-inkdeep text-xs tracking-[0.25em] uppercase font-medium group-hover:bg-gold-light transition-colors"
        >
          See What's Coming Up <ArrowRight size={15} aria-hidden="true" />
        </span>
      </Link>
    </section>
  );
}
